import { createFileRoute } from '@tanstack/react-router'
import { PlaygroundSubPane } from './-components/dev/transition-playground'

export const Route = createFileRoute('/_app/admin/transitions/jobs/$jobId/distribution/x')({
  component: () => <PlaygroundSubPane name="By level" />,
})
